module.exports = __webpack_public_path__ + "media/Audio17_s.8fa5b37f.wav";